<app-modal-shell [title]="title" size="sm" [closeDisabled]="loading" (closed)="close()">
  <div icon class="header-icon" [class.danger]="mode === 'delete'">
    <i class="bi" [class]="mode === 'delete' ? 'bi-exclamation-triangle-fill' : mode === 'edit' ? 'bi-pencil-fill' : 'bi-plus-lg'"></i>
  </div>

  @if (loading) {
    <app-loader />
  }

  @if (mode === 'delete') {
    <div class="confirm-panel">
      <p class="confirm-text">
        You're about to remove <strong>{{ service?.service_name }}</strong> from this tenant. This action can't be undone.
      </p>
    </div>
  } @else {
    <form [formGroup]="form" class="service-form">
      <div class="form-group">
        <label for="serviceId">Service ID</label>
        <div class="input-with-icon">
          <i class="bi bi-hash"></i>
          <input id="serviceId" type="number" placeholder="e.g. 3" formControlName="serviceId" />
        </div>
        <span class="field-hint">The numeric id of the service to assign to this tenant.</span>
        @if (form.controls.serviceId.invalid && form.controls.serviceId.touched) {
          <span class="field-error">Service ID is required.</span>
        }
      </div>

      @if (mode === 'edit') {
        <div class="toggle-row">
          <div>
            <div class="toggle-label">Active</div>
            <div class="toggle-hint">Inactive services are hidden from the tenant.</div>
          </div>
          <label class="switch">
            <input type="checkbox" formControlName="isActive" />
            <span class="switch-track"><span class="switch-thumb"></span></span>
          </label>
        </div>
      }
    </form>
  }

  <div footer>
    <button
      type="button"
      class="submit-btn"
      [class.danger]="mode === 'delete'"
      [disabled]="loading"
      (click)="submit()"
    >
      @if (mode === 'delete') {
        <i class="bi bi-trash"></i>
      } @else if (mode === 'edit') {
        <i class="bi bi-check-lg"></i>
      } @else {
        <i class="bi bi-plus-lg"></i>
      }
      <span>{{ mode === 'delete' ? 'Remove Service' : mode === 'edit' ? 'Save Changes' : 'Add Service' }}</span>
    </button>
  </div>
</app-modal-shell>
